<template>
  <!-- 新日账单明细 -->
  <div class="home-page-container">
    <!-- search 查询 -->
    <el-card shadow="never">
      <mer-search :searchConfig="formConfig" :searchBar="searchBar"
        @search="serchList"
        @reset="reset(initQuery, 'searchBar', {type: 'clickEvent', name: '结算账单明细（POS）重置', id: '1621476481'})"
        @changeTime="(value,model)=>changeTime(
          value,
          'searchBar',
          'orderSettlementTimeStart',
          'orderSettlementTimeEnd'
        )"
        :loading="tableLoading">
        <template slot="handler">
          <!-- <el-button size="mini" @click="download" icon="el-icon-download">导出</el-button> -->
          <download-button :downloadApi="downloadDailyDetailListApi" :queryParams="{ ...downloadParams }" style="margin-right: 10px;" @countPoint="$track.clickEvent('结算账单明细（POS）导出', '1621476480')"></download-button>
          <!-- <el-button size="mini" @click="gotoOldDetail">8月4日前账单明细 >>></el-button> -->
        </template>
      </mer-search>
    </el-card>
    <!-- summary 汇总信息 -->
    <sum-panel :labelMap="sumLabel" :sumInfo="sumInfo" :tipsInfo="tipsInfo"></sum-panel>
    <!-- table 表格 -->
    <el-card shadow="never">
      <mer-table :loading="tableLoading"
        :tableConfig="tableConfig"
        :tableData="tableData"
        :pagination="pagination"
        @SizeChange="handleSizeChange"
        @PageChange="pageChange"
        :hasIndex="false">
      </mer-table>
    </el-card>
  </div>
</template>
<script>
import listPage from '@/mixins/listPage'
import queryMix from '@/views/finance/mixins/query';
import dailyBillMix from '@/views/finance/mixins/posDailyBill';
import { getDailyDetailQueryApi, getDailyDetailSummaryApi, getDailyDetailListApi, downloadDailyDetailListApi } from '@/api/finance/posOrderDetail'
import { receiveBusinessList } from '@/api/finance'
import { getStationEnergyType } from '@/api/common'
import { mapState } from 'vuex'
// 埋点数据
let mdObj = {
  pageview: {
    type: 'pageViewEvent',
    name: '结算账单明细（POS）',
    id: '1621476445'
  },
  orderSettlementTimeEnd: {
    type: 'clickEvent',
    name: '结算账单明细（POS）时间选择',
    id: '1621476447'
  },
  gasId: {
    type: 'clickEvent',
    name: '结算账单明细（POS）油站',
    id: '1621476484'
  },
  orderType: {
    type: 'clickEvent',
    name: '结算账单明细（POS）账单类型',
    id: '1621476449'
  },
  receiveBusiness: {
    type: 'clickEvent',
    name: '结算账单明细（POS）结算方',
    id: '1621476483'
  },
  download: {
    type: 'clickEvent',
    name: '结算账单明细（POS）导出',
    id: '1621476480'
  }
}

// 查询表单配置
let formConfig = [
  { label: '油站', type: 'select', modelName: 'gasId', placeholder: '全部', selectOptions: [], define: true, selectLabel: 'gasName', selectValue: 'gasId' },
  { label: '订单号', type: 'input', modelName: 'orderCode', placeholder: '', maxlength: 100 },
  { label: '支付时间', type: 'date', modelName: 'tradeTime', model: '', dateType: 'datetimerange', format: 'yyyy-MM-dd HH:mm:ss',pickerOptions:{}, clearable:false },
  { label: '账单类型', type: 'select', modelName: 'orderType', placeholder: '全部', selectOptions: [], define: true, selectLabel: 'label', selectValue: 'value' },
  { label: '结算方', type: 'select', modelName: 'receiveBusiness', placeholder: '全部', selectOptions: [], define: true, selectLabel: 'label', selectValue: 'value' }
]
// 表格参数配置
let tableConfig = [
  { label: '订单号', prop: 'orderCode', width: 190 },
  { label: '油站名称', prop: 'gasName', width: 200 },
  { label: '订单结算时间', prop: 'dealTime', width: 150 },
  { label: '加油金额(元)', prop: 'amountGun', width: 136 },
  { label: '应结算金额(元)', prop: 'amount', width: 136 },
  { label: '通道费金额(元)', prop: 'slottingFee', width: 136 },
  { label: '实际结算金额(元)', prop: 'realSettlementAmount', width: 136 },
  { label: '结算方', prop: 'receiveBusinessName', width: 136 },
  { label: '油号', prop: 'oilNumName', width: 136 },
  { label: '枪号', prop: 'gunNo', width: 136 },
  { label: '升数', prop: 'litre', width: 136 },
  { label: '通道费结算周期', prop: 'slottingCycleName',width: 136 },
  { label: '账单类型', prop: 'orderTypeName',width: 136 },
  { label: '账单状态', prop: 'billStatusName',width: 136 },
]

export default {
  name: 'posBill_dailyBillDetail',
  mixins:[ listPage, queryMix, dailyBillMix ],
  data(){
    return{
      downloadDailyDetailListApi,
      isGas: null,
      tradeTime:'',
      formConfig,
      tableConfig
    }
  },
   created(){
    this.initPage()
    this.maidian(mdObj.pageview)
  },
  computed: {
    ...mapState('user', ['userInfo']),
  },
  methods:{
    maidian (obj) {
      const { type, name, id, other = {} } = obj
      this.$track[type](name, id, other)
    },
    initPage () {
      this.initQuery()
      this.getAllQueryProps()
      this.receiveBusinessListApi()
      this.refresh()
    },  
    // 设置默认查询条件，默认时间间隔2天
    initQuery () {
      this.tradeTime = ''
      this.initTime('tradeTime', 1, 'searchBar', false, 'orderSettlementTimeStart', 'orderSettlementTimeEnd')
      const { tradeTime, pickerOptions } = this
      const initObj = { tradeTime: [tradeTime, pickerOptions] }
      this.setSearchConfig(initObj)
    },
    getAllQueryProps(){
      this.getQueryStatus()
      //获取油站
      this.getAllGasStations()
    },
    // 查找目标表格索引
    findColumnIndex (key) {
      return this.tableConfig.findIndex(item => item.prop === key)
    },
    // 获取table ||  特殊的请求或数据处理，可以覆写该方法
    async refresh () {
      this.tableLoading = true
      const data = { ...this.searchBar, ...this.pagination }
      //对查询条件做一次缓存
      this.downloadParams = { ...this.searchBar }
      this.getSumInfo(data)
      // 判断是否是加气的站, 商户调取接口，需要传gasId,否则默认给油站数据，油站调取接口不需要传参
      if (!this.userInfo.company) {
        this.getStationEnergyTypeApi()
      } else {
        this.getStationEnergyTypeApi({ gasId: data.gasId })
      }
      try{
        const { code, result = [], totalRow = 0 } = await getDailyDetailListApi(data)
        if(code !== 200) return
        this.tableData.records = result
        this.tableData.total = parseInt(totalRow)
      }catch(err){
        console.log(err)
      }finally{
        this.tableLoading = false
      }
    },
    // 列表汇总（统计）信息
    async getSumInfo (data) {
      try{
        const { code, result } = await getDailyDetailSummaryApi(data)
        if(code !== 200) return
        this.sumInfo = result
      }catch(err){
        console.log(err)
      }
    },
    // 获取查询条件：交易类型
    async getQueryStatus () {
      try{
        const { code, result = [] } = await getDailyDetailQueryApi()
        if(code !== 200) return
        const initObj = { orderType: this.optionsWrapper(result) }
        this.setSearchConfig(initObj)
      }catch(err){
        console.log(err)
      }
    },
    // 判断当前油站是加气还是加油
    async getStationEnergyTypeApi (params) {
      try {
        const { code, result } = await getStationEnergyType(params)
        if(code !==200) return
        this.isGas = result
        this.tableConfig[this.findColumnIndex('oilNumName')].label = result === 2 ? '气号' : '油号'
        this.tableConfig[this.findColumnIndex('litre')].label = result === 2 ? '数量' : '升数'
        this.tableConfig[this.findColumnIndex('amountGun')].label = result === 2 ? '金额' : '加油金额'
        // 加气还是加油文案修改
        const type = result === 2 ? '气' : '油'
        this.sumLabel.totalOilAmount = `加${type}总金额(元)`
        this.tipsInfo.settlementAmount = `加${type}金额（枪价）- 商家让利金额（合同让利）`
        this.tipsInfo.realSettlementAmount = `加${type}金额-基础让利-通道费-商家承担优惠金额-平台承担优惠金额`
      } catch (error) {
        console.log(error)
      }
    },
    // 结算方式枚举
    async receiveBusinessListApi () {
      try {
        let { code, result } = await receiveBusinessList()
        if(code !== 200) return
        const initObj = { receiveBusiness: this.optionsWrapper(result.receiveBusiness) }
        this.setSearchConfig(initObj)
      } catch (error) {
        console.log(error)
      }
    },
    // 查询表格数据
    serchList () {
      this.search()
      let list = ['orderCode', 'orderSettlementTimeStart']
      Object.keys(this.searchBar).forEach(item => {
        if(!list.includes(item) && this.searchBar[item]) {
          let other = {}
          if(item === 'orderType') {
            other.tysj_trade_type = this.searchBar[item] === '10' ? '1' : '2'
          }
          if(item === 'orderSettlementTimeEnd') {
            other.tysj_start_time = this.searchBar.orderSettlementTimeStart
            other.tysj_end_time = this.searchBar.orderSettlementTimeEnd
          }
          mdObj[item].other = other
          this.maidian(mdObj[item])
        }
      })
    },
    //导出
    download () {
      this.maidian(mdObj.download)
      this.downloadFile(downloadDailyDetailListApi,'结算日账单明细')
    },
    gotoOldDetail(){
      this.$router.push({path:'/bill/oldBillDetailList'})
    },
  }
}
</script>
<style lang="less" scoped>
.home-page-container{
  margin-top: 20px;
}
</style>
